const cardItems = [
  {
    title: '台北娜娜 · 独家爆料合集',
    desc: '台北娜娜最新动态与独家视频爆料，包含多角度深度分析，持续追踪这位热门人物的每一个精彩瞬间。',
    img: 'https://readdy.ai/api/search-image?query=A%20mysterious%20cinematic%20scene%20with%20warm%20dramatic%20lighting%2C%20silhouette%20of%20a%20female%20figure%20against%20a%20dark%20backdrop%20with%20neon%20orange%20and%20red%20accents%2C%20editorial%20photography%20style%2C%20atmospheric%2C%20no%20text%2C%20modern%20aesthetic&width=800&height=500&seq=card-taipei-nana&orientation=landscape',
    tag: '热门人物',
    hot: true,
  },
  {
    title: '莫里秀 · 黑料深度揭秘',
    desc: '51吃瓜莫里秀专题：从多维度揭秘莫里秀不为人知的故事，全程跟踪报道，带你揭开真相的层层面纱。',
    img: 'https://readdy.ai/api/search-image?query=A%20dramatic%20dark%20scene%20with%20spotlight%20effect%2C%20a%20mysterious%20male%20silhouette%20in%20the%20center%2C%20warm%20golden%20and%20red%20lighting%2C%20cinematic%20mood%2C%20investigative%20journalism%20aesthetic%2C%20no%20text%2C%20high%20contrast&width=800&height=500&seq=card-molixiu&orientation=landscape',
    tag: '深度揭秘',
    hot: true,
  },
  {
    title: '玩偶姐姐 · 精彩视频精选',
    desc: '玩偶姐姐最新视频内容精选集，含精彩片段解读和独家幕后花絮，带你全面了解这位热门创作者的全部动态。',
    img: 'https://readdy.ai/api/search-image?query=A%20stylish%20dark%20studio%20scene%20with%20warm%20pink%20and%20orange%20ambient%20lighting%2C%20creative%20video%20production%20setup%20vibe%2C%20elegant%20silhouette%20with%20modern%20aesthetic%2C%20no%20text%2C%20fashion%20editorial%20style&width=800&height=500&seq=card-wanou&orientation=landscape',
    tag: '视频精选',
    hot: false,
  },
  {
    title: '暗网吃瓜 · 人物专题总览',
    desc: '暗网吃瓜人物专题每日更新，汇集全网最热门的100+人物资讯，从台北娜娜到玩偶姐姐，一站看尽所有爆料。',
    img: 'https://readdy.ai/api/search-image?query=A%20dark%20grid%20of%20multiple%20mysterious%20silhouettes%20with%20warm%20glowing%20orange%20accents%2C%20organized%20like%20a%20gallery%20wall%2C%20cinematic%20lighting%2C%20dramatic%20mood%2C%20no%20text%2C%20editorial%20photography&width=800&height=500&seq=card-characters&orientation=landscape',
    tag: '专题合集',
    hot: false,
  },
  {
    title: '51吃瓜 · 每日最新快讯',
    desc: '51吃瓜旗下每日更新的最新爆料汇总，包含台北娜娜动态、莫里秀新料以及各类突发八卦，保证不让你错过任何热点。',
    img: 'https://readdy.ai/api/search-image?query=A%20dark%20newsroom%20style%20scene%20with%20multiple%20floating%20headlines%20in%20warm%20orange%20glow%2C%20dramatic%20atmosphere%2C%20breaking%20news%20aesthetic%2C%20no%20text%2C%20cinematic%20lighting&width=800&height=500&seq=card-daily-news&orientation=landscape',
    tag: '每日快讯',
    hot: true,
  },
  {
    title: '吃瓜爆料 · 社区热帖精选',
    desc: '从暗网吃瓜社区精选的优质爆料帖文，汇聚吃瓜群众的真实讨论与观点，为你呈现最接地气的八卦视角。',
    img: 'https://readdy.ai/api/search-image?query=A%20vibrant%20dark%20community%20scene%20with%20warm%20amber%20and%20red%20lighting%2C%20multiple%20floating%20message%20bubbles%20in%20subtle%20glow%2C%20social%20media%20aesthetic%2C%20no%20text%2C%20modern%20editorial%20style&width=800&height=500&seq=card-community&orientation=landscape',
    tag: '社区热帖',
    hot: false,
  },
];

export default function CardsSection() {
  return (
    <section id="cards" className="py-14 md:py-20 bg-background-100/50">
      <div className="w-full px-4 md:px-6">
        <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 text-center">
          热门人物专题
        </h2>
        <p className="mt-2 text-sm text-foreground-500 text-center">
          精选六大人气专题，发现最新鲜的吃瓜内容
        </p>
        <div className="mt-8 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {cardItems.map((item, i) => (
            <a
              key={i}
              href="#"
              onClick={(e) => e.preventDefault()}
              className="group block rounded-xl border border-background-200/60 bg-background-50 overflow-hidden transition-all duration-300 hover:border-primary-500/30 hover:translate-y-[-2px] cursor-pointer"
            >
              <div className="relative aspect-[16/10] overflow-hidden bg-background-200">
                <img
                  src={item.img}
                  alt={item.title}
                  className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                />
                <div className="absolute top-3 left-3 flex items-center gap-2">
                  <span className="px-2.5 py-1 rounded-full bg-background-950/70 backdrop-blur-sm text-xs text-foreground-200 font-medium">
                    {item.tag}
                  </span>
                  {item.hot && (
                    <span className="px-2 py-1 rounded-full bg-primary-500/80 text-xs text-white font-medium flex items-center gap-1">
                      <i className="ri-fire-line text-[10px]"></i>热
                    </span>
                  )}
                </div>
              </div>
              <div className="p-4 md:p-5">
                <h3 className="text-base md:text-lg font-heading font-semibold text-foreground-900 group-hover:text-primary-400 transition-colors">
                  {item.title}
                </h3>
                <p className="mt-2 text-sm text-foreground-500 leading-relaxed line-clamp-2">
                  {item.desc}
                </p>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}